import { writable } from 'svelte/store';
import type { ModalConfig } from 'src/types/Modals';
import { ModalManager } from 'src/services/modal-manager';

function createModalStore() {
	const { subscribe, set } = writable<ModalConfig[]>([]);
	let manager: ModalManager | null = null;
	let isInitialized = false;

	return {
		subscribe,
		initManager: (initialModals: ModalConfig[]) => {
			isInitialized = true;
			manager = new ModalManager(initialModals);
			const activeModals = manager.getActiveModals();
			set(activeModals);

			return manager;
		},
		setModals: (modals: ModalConfig[]) => {
			if (!manager) return;
			const activeModals = manager.setModals(modals);
			set(activeModals);
		},
		addModal: (modal: ModalConfig) => {
			if (!manager) return;
			const queue = manager.addModal(modal);
			set(queue);
		},
		showModal: (modal: ModalConfig) => {
			const queue = manager.showModal(modal);
			set(queue);
		},
		hideModal: (modalId: string) => {
			const queue = manager.hideModal(modalId);
			set(queue);
		},
		isInitialized: () => {
			return isInitialized;
		},
		setIsInitialized: (value: boolean) => {
			isInitialized = value;
		},
	};
}

export const modalStore = createModalStore();
export const isReadyToInitializeModalsStore = writable<boolean>(false);
